import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Backdrop from '@mui/material/Backdrop';

import { toast } from 'react-toastify';

import '../../assets/style/style.css';

import CircularProgress from '@mui/material/CircularProgress';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import configurationContext  from "contextConfig";
import { useParams, useNavigate } from 'react-router-dom';

import { useMaterialUIController, setRefundContext } from "context";

import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";

import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";

import DataTable from "layouts/Tables/DataTable";

import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { handleErrors, dateTimeFormat } from "common.js";
import { useTranslation } from "react-i18next";
import MDButton from "components/MDButton";

function List() {

  const [controller, dispatch, initialState] = useMaterialUIController();
  const { refundContext }      = controller;

  const statusFilter   = refundContext.statusFilter;
  const typeFilter     = refundContext.typeFilter;
  const orderBy        = refundContext.orderBy;
  const orderValue     = refundContext.orderValue;
  const searchBy       = refundContext.searchBy;
  const searchValue    = refundContext.searchValue;

  const navigate   = useNavigate();

  const { pageNo } = useParams();

  var pageSelected     = 1;

  if(typeof pageNo !== "undefined")
  {
      const parts  = pageNo.split("-");
      pageSelected = parts[1].trim();
  }

  const { t } = useTranslation();

  const MyContext = useContext(configurationContext);

  const BASE  = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);
  const [dataTableData, setDataTableData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const [isRefundContextChanged, setRefundContextChanged] = useState(false);


  useEffect(() => {
    listRefunds();
  }, [pageNo]);

  const handleResetFilters = () => {
    setRefundContext(dispatch, initialState.refundContext);
    setRefundContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/refunds/list/page-1");
    else
      navigate("/refunds/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(refundContext).some(
      key => refundContext[key] !== initialState.refundContext[key]
    );
    setRefundContextChanged(hasChanged);
  }, [refundContext]);

  const handleChangeOrderBy = (event: SelectChangeEvent) => {
    setRefundContext(dispatch, { ...refundContext, orderBy: event.target.value});
  };

  const handleChangeOrderByType = (event: SelectChangeEvent) => {
    setRefundContext(dispatch, { ...refundContext, orderValue: event.target.value});
  };

  const handleChangeStatusFilter = (event: SelectChangeEvent) => {
    setRefundContext(dispatch, { ...refundContext, statusFilter: event.target.value});
  };

  const handleChangeTypeFilter = (event: SelectChangeEvent) => {
    setRefundContext(dispatch, { ...refundContext, typeFilter: event.target.value});
  };

  const handleChangeSearchBy = (event: SelectChangeEvent) => {
    setRefundContext(dispatch, { ...refundContext,
      searchBy: event.target.value,
      searchValue: '',
    });
  };

  const handleChangeSearchByValue = (event) => {
    setRefundContext(dispatch, { ...refundContext, searchValue: event.target.value});
  };

  const renderOrderByList = (
    <>
      <InputLabel>{t('Order By')}</InputLabel>
      <Select
          id="order-by"
          value={orderBy}
          label={t('Order By')}
          onChange={handleChangeOrderBy}
          className='filterStyle'
        >
        <MenuItem value='orderid'>{t('Refund ID')}</MenuItem>
      </Select>
    </>
  );

  const renderOrderByType = (
    <>
      <InputLabel>{t('order')}</InputLabel>
      <Select
          id="order-by-type"
          label={t('order')}
          value={orderValue}
          onChange={handleChangeOrderByType}
          className='filterStyle'
        >
        <MenuItem value='desc'>{t('Desc')}</MenuItem>
        <MenuItem value='asc'>{t('Asc')}</MenuItem>
      </Select>
    </>
  );

  const renderRefundStatusList = (
    <>
      <InputLabel>{t('Refund Status')}</InputLabel>
      <Select
          id="refund-status"
          value={statusFilter}
          label={t('Refund Status')}
          onChange={handleChangeStatusFilter}
          className='filterStyle'
        >
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='approved'>{t('approved')}</MenuItem>
        <MenuItem value='pending'>{t('Pending')}</MenuItem>
      </Select>
    </>
  );


  const renderRefundTypeList = (
    <>
      <InputLabel>{t('Refund Type')}</InputLabel>
      <Select
          id="refund-type"
          value={typeFilter}
          label={t('Refund Type')}
          onChange={handleChangeTypeFilter}
          className='filterStyle'
        >
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='customer return'>{t('customer return')}</MenuItem>
        <MenuItem value='vendor reject'>{t('vendor reject')}</MenuItem>
      </Select>
    </>
  );


  const renderSearchByList = (
    <>
      <InputLabel>{t('Search By')}</InputLabel>
      <Select
          id="search-by"
          value={searchBy}
          label={t('Search By')}
          onChange={handleChangeSearchBy}
          className='filterStyle'
        >
        <MenuItem value="none">{t('None')}</MenuItem>
        <MenuItem value="orderId">{t('Vendor Order ID')}</MenuItem>
        <MenuItem value="shopifyOrderID">{t('Shopify Order ID')}</MenuItem>
        <MenuItem value="returnId">{t('Return ID')}</MenuItem>
        <MenuItem value="vendorShopName">{t('Shop Name')}</MenuItem>
        <MenuItem value="customerEmail">{t('Customer Email')}</MenuItem>
      </Select>
    </>
  );

  const listRefunds = () => {

    setIsLoading(true);

    const requestPayLoad = "statusFilter="+statusFilter+"&typeFilter="+typeFilter+"&orderBy="+orderBy+"&orderValue="+orderValue+"&searchBy="+searchBy+"&searchValue="+searchValue+"&pageSelected="+pageSelected;

    axios({
          url     : BASE+"api/refund/list?"+requestPayLoad,
          method  : "GET",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },

        }).then(function (response)
        {
            const responseData           = response.data;
            const responseDataStatusCode = response.data.status;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);

                if(responseDataStatusCode === 0)
                {
                    toast.error(t('An unexpected error occurred while communicating with server'));
                    return;
                }
                else if(responseDataStatusCode === 1 && responseData.data && responseData.data.rows)
                {
                    const columns  =  [
                      { Header: `${t("ID")}`, accessor: "id", align: "left" },
                      { Header: `${t("Shop Name")}`, accessor: "vendorShop", align: "left" },
                      { Header: `${t("Vendor Order ID")}`, accessor: "orderVendorId", align: "left"},
                      { Header: `${t("Shopify Order ID")}`, accessor: "shopifyOrderID", align: "left" },
                      { Header: `${t("Transaction Type")}`,accessor: "transactionType", align: "left" },
                      { Header: `${t("Order Return ID")}`, accessor: "returnReferenceId", align: "left" },
                      { Header: `${t("Refund Amount")}`, accessor: "totalPrice", align: "right" },
                      { Header: `${t("Customer Email")}`, accessor: "customerEmail", align: "left"},
                      { Header: `${t("status")}`, accessor: "refundedStatus", align: "left" },
                      { Header: `${t("Created Date")}`, accessor: "date", align: "left" },
                      { Header: `${t("Action")}`, accessor: "action", align: "left" }
                    ];

                    var rows = [];


                    responseData.data.rows.map((item, index) => {

                        let refundStatusBox;

                        if(item.refundedStatus === 'pending')
                        refundStatusBox = <Box className="refundStatusBoxPending">{t("Pending")}</Box>
                        else
                        refundStatusBox = <Box className="refundStatusBoxApprove">{t(item.refundedStatus)}</Box>

                        var tempData = {
                          "id"                : item.id,
                          "vendorShop"        : item.vendorShop,
                          "orderVendorId"     : <Box>{"#"+item.orderVendorId}</Box>,
                          "shopifyOrderID"    : item.shopifyOrderID,
                          "transactionType"   : <Box>{t(item.transactionType)}</Box>,

                          "returnReferenceId" : item.returnReferenceId,
                          "totalPrice"        : <Box>{`₹${item.totalPrice.toFixed(2)}`}</Box>,
                          "customerEmail"     : item.customerEmail,
                          "refundedStatus"    : refundStatusBox,
                          "date"              : dateTimeFormat(item.createdAt),
                          "action"            : <Link href={"#"} onClick={(event) => { event.preventDefault(); navigate("/refunds/details/"+item.id) }} ><Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("View")} /></Box></Link>,
                        };

                      rows.push(tempData);
                    });

                    setDataTableData({ columns, rows });
                    setResponseResultCount(responseData.data.totalCount);
                }
            }
            else
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;
            }
        }).catch(function (error) {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }

  return (
      <DashboardLayout>
        <DashboardNavbar pageTitle={t('manageRefunds')} />

        {isLoading ? (
            <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
        ) : <></> }

        <MDBox my={3} className="ContentSectionBox">

          <MDBox className="ManageProductTopSec" mx={2}
                  mt={0}
                  py={3}
                  px={2}
                  variant="gradient">

          <Grid container className="FilterSectionBox" spacing={2}
            sx={searchBy !== "none" ? { justifyContent: 'center' } : {}}
          >
              <Grid item md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderRefundStatusList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

              <Grid item md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderRefundTypeList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

              <Grid item md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderSearchByList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

              {searchBy != "none" ?
                <Grid item md={2} sm={3} xs={6}>  
                  <FormControl className='formcontrolFilterStyle'>
                    <InputLabel className='SearchInputHead'>{t('Search Input')}</InputLabel>
                    <TextField 
                      variant = "outlined" 
                      value = {searchValue}
                      onChange={handleChangeSearchByValue}
                    />
                  </FormControl>
                </Grid>
                :<></>
              }
              <Grid item md={2} sm={3} xs={6}>
                  <FormControl className='formcontrolFilterStyle'>
                    {renderOrderByList}
                    <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                  </FormControl>
              </Grid>

              <Grid item md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderOrderByType}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

              <Grid item md={2} sm={3} xs={6} className="actionGrid">
                <FormControl className="filterSubmit">
                    <MDButton
                      key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple
                      onClick={() => {

                        navigate( "/refunds/list" );

                        if(typeof pageNo === "undefined")
                        listRefunds();
                      }}
                    >{t('Submit')}</MDButton>
                    {isRefundContextChanged && (
                        <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="SubmitButton" disableRipple >{t('reset')}</MDButton>
                    )}
                </FormControl>            


              </Grid>
          </Grid>
          </MDBox>
          <MDBox pt={3}>
            {dataTableData.columns && dataTableData.columns.length > 0 ?
              <DataTable
                table={dataTableData}
                isSorted={false}
                showTotalEntries={true}
                responseResultCount={responseResultCount}
                paginationSize = {MyContext.paginationSize}
                paginationLink = {"/refunds/list/page-"}
                pageSelected = {pageSelected}
              />
            : <></>}
          </MDBox>

        </MDBox>
      </DashboardLayout>
  );
}

export default List;
